module.exports = __webpack_public_path__ + "static/img/2.0802d98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pro/park/2.png
// module id = raRg
// module chunks = 0